/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';

jQuery( document ).on( 'scroll', function() {
	const headerSection = jQuery( '.header-section' );

	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
		if ( jQuery( window ).width() > 1023 ) {
			if ( headerSection.hasClass( 'transparent-header' ) ) {
				headerSection.addClass( 'white-header' );
				headerSection.removeClass( 'transparent-header' );
			}

			if (
				headerSection.hasClass( 'transparent-header' ) &&
				headerSection.hasClass( 'shrink' )
			) {
				headerSection.on( 'mouseleave', function() {
					jQuery( this ).addClass( 'white-header' );
				} );
			}
		}
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
		if ( ! jQuery( 'header' ).hasClass( 'initially-white-header' ) ) {
			headerSection.removeClass( 'white-header' );
		}

		if ( jQuery( window ).width() > 1023 ) {
			if (
				headerSection.hasClass(
					'white-header' &&
						headerSection.hasClass( 'initially-white-header' ),
				)
			) {
				headerSection.removeClass( 'white-header' );
				headerSection.addClass( 'transparent-header' );
			} else {
				headerSection.addClass( 'initially-white-header' );
			}

			if ( headerSection.hasClass( 'transparent-header' ) && ! headerSection.hasClass( 'shrink' ) ) {
				headerSection.on( 'mouseenter', function() {
					jQuery( this ).addClass( 'white-header' );
				} );
			}
		}
	}
} );

// Header Section Data Sets
const lastScrollTop = 0,
	delta = 15,
	headerSection = jQuery( '.header-section' ),
	heroFixedVavCtn = jQuery( '.hero-fixed-nav-ctn' ),
	topBar = jQuery( '.top-bar' ),
	navOverlay = jQuery( '.nav-overlay' ),
	body_header = jQuery( 'header,body' );
jQuery( window ).on( 'load', function() {
	if ( jQuery( window ).width() > 1023 ) {
		if ( jQuery( '.header-section' ).hasClass( 'transparent-header' ) ) {
			jQuery( '.header-section' ).on( 'mouseenter', function() {
				jQuery( '.header-section' ).addClass( 'white-header' );
			} );

			jQuery( '.header-section' ).on( 'mouseleave', function() {
				jQuery( '.header-section' ).removeClass( 'white-header' );
			} );
		}
	}

	// if (!jQuery('.top-bar').hasClass('hide-top-bar')) {
	const topBar_height = jQuery( '.top-bar' ).outerHeight();
	let logedin_topBar_height = jQuery( '.top-bar' ).outerHeight();
	const $header_height = jQuery( '.header-section' ).outerHeight();
	const $header_inner = jQuery( '.header-inner' ).outerHeight();
	const $wpAdminBar = jQuery( '#wpadminbar' ).outerHeight();
	const $paddingTopValue = jQuery( '.hero--home' ).css( 'padding-top' );

	let adjustment = 0;
	if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
		adjustment = 32;
		logedin_topBar_height = topBar_height - adjustment;

		if ( jQuery( window ).width() < 783 ) {
			adjustment = 46;
			logedin_topBar_height = topBar_height - adjustment;
		}
	}

	// Update styles for .hero-section
	jQuery( '.header-section' ).css( 'top', adjustment + 'px' );

	jQuery( '.top-bar-cross' ).on( 'click', function() {
		jQuery( '.top-bar' ).addClass( 'hide-top-bar' );
		jQuery( '.header-section' ).css(
			'top',
			'-' + logedin_topBar_height + 'px',
		);
	} );
} );

jQuery( function() {
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( 'ul' ).addClass( 'focused' );
			jQuery( this ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( 'ul' ).removeClass( 'focused' );
			jQuery( this ).removeClass( 'focused' );
		} );

	jQuery( '.mega-menu a' )
		.focus( function() {
			jQuery( this ).closest( '.mega-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).closest( '.mega-menu' ).removeClass( 'focused' );
		} );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	jQuery.noConflict();

	jQuery( '.menu-btn' ).on( 'click', function() {
		if ( jQuery( '.menu-btn' ).hasClass( 'active' ) ) {
			jQuery( '.header-section,.mega-menu' ).removeClass(
				'active-mega-menu',
			);
		} else {
			jQuery( '.header-section,.mega-menu' ).removeClass(
				'active-mega-menu',
			);
		}
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( document ).on( 'click', '.header-nav .menu-item span', function() {
		const link = jQuery( this ).parents( 'li' );
		if ( link.hasClass( 'active' ) ) {
			link.removeClass( 'active' );
			link.parents( 'ul' ).removeClass( 'disabled-menu' );
		} else {
			link.addClass( 'active' );
			link.parents( 'ul' ).addClass( 'disabled-menu' );
		}
	} );

	jQuery( document ).on( 'click', '.submenu-icon', function() {
		jQuery( this ).parents( '.header-nav' ).addClass( 'active-ul' );
		jQuery( '.header-section' ).toggleClass( 'active-mega-menu' );
		jQuery( this )
			.parent()
			.find( '.mega-menu' )
			.toggleClass( 'active-mega-menu' );
		jQuery( this ).parent().find( 'ul' ).toggleClass( 'active-dropdown' );
	} );

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.main-menu-item' ).each( function() {
			const menuBackLink = jQuery( '.mega-menu-back-button' );
			menuBackLink.on( 'click', function() {
				jQuery( '.header-section, .mega-menu' ).removeClass(
					'active-mega-menu',
				);
			} );
		} );
	}

	/**
	 * Tabbed Content with link
	 */

	jQuery( '#tabbed-content-wlink' ).organicTabs( {
		speed: 200,
	} );

	/**
	 * Tabbed Content with Image
	 */

	jQuery( '#tabbed-content-wImage' ).organicTabs( {
		speed: 200,
	} );

	/**
	 * Tabbed Content with Logos
	 */

	jQuery( '#tabbed-content-wlogos' ).organicTabs( {
		speed: 200,
	} );

	/**
	 * play video
	 */

	document.querySelectorAll( '.tcci-thumbnail-image' ).forEach( ( thumbnail ) => {
		thumbnail.addEventListener( 'click', function() {
			const nextSibling = this.nextElementSibling;
			if ( nextSibling.tagName.toLowerCase() === 'video' ) {
				nextSibling.play();
			} else if ( nextSibling.tagName.toLowerCase() === 'iframe' ) {
				const iframeSrc = nextSibling.getAttribute( 'src' );
				if ( iframeSrc ) {
					nextSibling.setAttribute( 'src', iframeSrc );
				}
			}
			this.style.display = 'none';
		} );
	} );

	/**
	 * IAT Text Slider
	 */

	// Owl Carousel
	const owl = jQuery( '.iat-ts-inner' );
	owl.owlCarousel( {
		items: 1,
		margin: 0,
		loop: true,
		nav: true,
		dots: false,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		animateIn: 'fadeInRight',
	} );

	/**
	 * Home Hero Newsroom Slider
	 */

	// Owl Carousel
	// jQuery( '.hh-newsroom-slider' ).owlCarousel( {
	// 	items: 2,
	// 	margin: 0,
	// 	loop: true,
	// 	nav: true,
	// 	dots: false,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			nav: false,
	// 			dots: true,
	// 			autoHeight: true,
	// 		},
	// 		768: {
	// 			items: 2,
	// 			nav: false,
	// 			dots: true,
	// 			autoHeight: true,
	// 		},

	// 		1024: {
	// 			items: 2,
	// 			nav: true,
	// 			dots: false,
	// 		},
	// 	},
	// } );
	/**
	 * Case Studies slider
	 */

	// jQuery( function() {
	// 	// Owl Carousel
	// 	const owl = jQuery( '.cs-slider' );
	// 	owl.owlCarousel( {
	// 		items: 1,
	// 		margin: 10,
	// 		loop: true,
	// 		nav: true,
	// 		dots: false,
	// 		autoplay: true,
	// 		autoplayTimeout: 5000,
	// 		autoplayHoverPause: true,
	// 		responsive: {
	// 			0: {
	// 				nav: false,
	// 				dots: true,
	// 			},
	// 			768: {
	// 				nav: false,
	// 				dots: true,
	// 				items: 2,
	// 			},

	// 			1024: {
	// 				items: 1,
	// 			},
	// 		},
	// 	} );
	// } );

	/**
	 * LOGO Grid testimonial slider
	 */

	// Owl Carousel
	// jQuery( '.lg-testimonials' ).owlCarousel( {
	// 	stagePadding: 10,
	// 	items: 2,
	// 	margin: 10,
	// 	loop: true,
	// 	nav: true,
	// 	dots: false,
	// 	autoplay: true,
	// 	autoplayTimeout: 5000,
	// 	autoplayHoverPause: true,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			stagePadding: 0,
	// 			loop: false,
	// 		},
	// 		747: {
	// 			items: 2,
	// 			nav: true,
	// 		},
	// 	},
	// } );

	/**
	 * Ebook Teaser slider
	 */

	// Owl Carousel
	// jQuery( '.ebook-teaser-slider' ).owlCarousel( {
	// 	items: 2,
	// 	margin: 20,
	// 	loop: true,
	// 	nav: true,
	// 	dots: false,
	// 	autoHeight: true,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 			stagePadding: 0,
	// 			loop: false,
	// 			nav: false,
	// 			dots: true,
	// 		},
	// 		748: {
	// 			items: 2,
	// 			nav: true,
	// 			dots: false,
	// 		},
	// 	},
	// } );

	/**
	 * Video alongside text slider
	 */

	// Owl Carousel
	jQuery( '.vat-text-slider' ).owlCarousel( {
		items: 1,
		margin: 0,
		loop: false,
		nav: true,
		dots: false,
		autoHeight: true,
	} );
	/*
	 * Stats slider
	 */

	// Owl Carousel

	jQuery( '.team-slider .team-members' ).owlCarousel( {
		items: 4,
		loop: false,
		nav: true,
		dots: false,
		margin: 20,
		responsiveClass: true,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 3,
			},
			1000: {
				items: 3,
			},
			1180: {
				items: 4,
			},
		},
	} );

	/**
	 * Timeline slider
	 */

	// Owl Carousel

	jQuery( '.timeline-slider' ).owlCarousel( {
		items: 3,
		loop: true,
		nav: true,
		dots: false,
		responsiveClass: true,
		autoplay: true,
		autoplayTimeout: 3000,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 2,
			},
			1000: {
				items: 3,
			},
		},
	} );

	// Map box slider

	// jQuery( '.map-box-slider' ).slick( {
	//     dots: false,
	//     nav: false,
	//     infinite: true,
	//     speed: 500,
	//     slidesToShow: 1,
	//     slidesToScroll: 1,
	//     variableWidth: true,
	//     centerMode: true, // Enable center mode
	//     focusOnSelect: true, // Prevent scroll to top on click
	//     touchThreshold: 150,
	//     responsive: [
	//         {
	//             breakpoint: 747,
	//             settings: {
	//                 slidesToShow: 1,
	//             },
	//         },
	//     ],
	// } );

	/**
	 * Stats slider
	 */

	// Owl Carousel
	jQuery( '.stats-slider' ).owlCarousel( {
		items: 1,
		nav: true,
		dots: false,
		autoHeight: true,
		responsive: {
			0: {
				autoHeight: true,
			},
			1023: {
				items: 1,
			},
		},
	} );

	const $slider = jQuery( '.stats-slider' ).owlCarousel( {
		items: 1, // Adjust the number of items based on your requirement
		loop: true,
		nav: true,
		dots: true,
		// Add any other options you need
	} );

	// Get the total number of slides
	const totalSlides = $slider.find( '.owl-item' ).length;

	// Initialize progress line width
	const progressLine = jQuery( '.progress-line' );
	const progressSpan = progressLine.find( 'span' );

	// Initial fill for the first slide
	progressSpan.css( 'width', ( 1 / totalSlides ) * 100 + '%' );

	// Function to update progress bar
	function updateProgress( currentSlide ) {
		const progressWidth = ( ( currentSlide + 1 ) / totalSlides ) * 100;
		progressSpan.css( 'width', progressWidth + '%' );
	}

	// Listen to Owl Carousel's changed event
	$slider.on( 'changed.owl.carousel', function( event ) {
		const currentSlide = event.item.index; // Owl Carousel provides the current index in the event object
		updateProgress( currentSlide );
	} );

	jQuery( '.header-search-button' ).on( 'click', function() {
		console.log( 'Search button clicked' );
		jQuery( '.header-section-input' ).addClass( 'show-search' );
		const inputElement = jQuery( '.header-section-input' ).find(
			'input[type="search"]',
		);
		if ( jQuery( window ).width() < 1004 ) {
			setTimeout( () => {
				console.log( 'Focusing on input:', inputElement );
				inputElement.focus();
			}, 100 );
		}
	} );

	jQuery( '.close-search-bar' ).on( 'click', function() {
		console.log( 'Close button clicked' );
		jQuery( '.header-section-input' ).removeClass( 'show-search' );
	} );

	/**
	 * FAQ Block
	 */

	// jQuery( '.faq > span,.language-top' ).on( 'click', function() {
	// 	if ( jQuery( this ).parent().hasClass( 'active' ) ) {
	// 		jQuery( this ).parent().removeClass( 'active' );
	// 		jQuery( this ).siblings( '.faq-content,#language-dropdown' ).slideUp();
	// 	} else {
	// 		jQuery( '.faq > span,.language-top' ).parent().removeClass( 'active' );
	// 		jQuery( this ).parent().addClass( 'active' );
	// 		jQuery( '.faq-content' ).slideUp();
	// 		jQuery( this )
	// 			.siblings( '.faq-content,#language-dropdown' )
	// 			.slideDown();
	// 	}
	// } );

	// jQuery( '.faq > span, .language-top' ).on( 'keydown', function( e ) {
	// 	if ( e.key === 'Enter' || e.key === ' ' ) {
	// 		e.preventDefault();
	// 		jQuery( this ).trigger( 'click' );
	// 	}
	// } );

	jQuery( document ).on( 'click', function( event ) {
		const $target = jQuery( event.target );

		// Check if the clicked element is not inside the .language-dropdown-menu
		if ( ! $target.closest( '.language-dropdown-menu' ).length ) {
			jQuery( '.language-dropdown-menu' ).removeClass( 'active' );
			jQuery( '#language-dropdown' ).slideUp();
		}
	} );

	// Prevent the menu from closing when clicking inside of it
	jQuery( '.language-dropdown-menu' ).on( 'click', function( event ) {
		event.stopPropagation();
	} );

	// Make the first child active when the page loads
	jQuery( '.faq:first-child > span' ).trigger( 'click' );

	/**
	 * IAT Accordion
	 */
	jQuery( '.iat-accordian > span' ).on( 'click', function() {
		if ( jQuery( this ).parent().hasClass( 'active' ) ) {
			jQuery( this ).parent().removeClass( 'active' );
			jQuery( this ).siblings( '.iat-accordian-content' ).slideUp();
		} else {
			jQuery( '.iat-accordian > span' ).parent().removeClass( 'active' );
			jQuery( this ).parent().addClass( 'active' );
			jQuery( '.iat-accordian-content' ).slideUp();
			jQuery( this ).siblings( '.iat-accordian-content' ).slideDown();
		}
	} );

	jQuery( '.iat-accordian > span' ).on( 'keydown', function( e ) {
		if ( e.key === 'Enter' || e.key === ' ' ) {
			e.preventDefault();
			jQuery( this ).trigger( 'click' );
		}
	} );

	jQuery( '.subscription-packages-plan-top' ).on( 'click', function() {
		if ( jQuery( this ).parent().hasClass( 'active' ) ) {
			jQuery( this ).parent().removeClass( 'active' );
			jQuery( this )
				.siblings( '.subscription-packages-plan-bottom' )
				.slideUp();
		} else {
			jQuery( '.subscription-packages-plan-top' )
				.parent()
				.removeClass( 'active' );
			jQuery( this ).parent().addClass( 'active' );
			jQuery( '.subscription-packages-plan-bottom' ).slideUp();
			jQuery( this )
				.siblings( '.subscription-packages-plan-bottom' )
				.slideDown();
		}
	} );

	jQuery( '.mobile-dropdown-head' ).on( 'click', function() {
		const mostParent = jQuery( this ).closest( '.tabbed-content-ctn' );
		const parent = jQuery( this ).parent();

		if ( parent.hasClass( 'current' ) ) {
			parent.removeClass( 'current' );
			jQuery( this )
				.siblings( '.tc-content-inner,.tabbed-content-row' )
				.slideUp();
		} else {
			// jQuery( '.mobile-dropdown-head' ).parent().removeClass( 'current' );
			mostParent.find( '.tabbed-content' ).removeClass( 'current' );
			parent.addClass( 'current' );
			mostParent.find( '.tc-content-inner,.tabbed-content-row' ).slideUp();
			jQuery( this )
				.siblings( '.tc-content-inner,.tabbed-content-row' )
				.slideDown();
		}
	} );

	// Make the first child active when the page loads
	jQuery( '.iat-accordian:first-child > span' ).trigger( 'click' );

	/**
	 * icon slider
	 */
	jQuery( '.icon-single-slide' ).on( 'click', function() {
		const $this = jQuery( this );
		if ( $this.hasClass( 'open' ) ) {
			$this.children( '.icon-slide-right' ).show();
		} else {
			jQuery( '.icon-single-slide' )
				.removeClass( 'open' )
				.children( '.icon-slide-right' )
				.hide();
			$this.addClass( 'open' );
			setTimeout( function() {
				$this.children( '.icon-slide-right' ).show();
			}, 200 ); // Adjust the delay time (in milliseconds) as needed
		}
	} );
	jQuery( '.icon-single-slide' ).on( 'keydown', function( e ) {
		if ( e.key === 'Enter' || e.key === ' ' ) {
			e.preventDefault();
			jQuery( this ).trigger( 'click' );
		}
	} );

	// Make the first child active when the page loads
	setTimeout( function() {
		jQuery( '.icon-single-slide:first-child' ).trigger( 'click' );
	}, 50 ); // Adjust the delay time (in milliseconds) as needed

	jQuery( '.iframe-popup,.video-iframe-popup' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'iframe-video-popup',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: true,
	} );

	jQuery( '.video-inline-popup' ).magnificPopup( {
		type: 'inline',
		preloader: false,
		modal: true,
		mainClass: 'iframe-inline-popup',
		removalDelay: 160,
		fixedContentPos: true,
	} );

	jQuery( document ).on( 'click', '.popup-modal-dismiss', function( e ) {
		e.preventDefault();
		jQuery.magnificPopup.close();
	} );

	jQuery( '.popup-link' ).magnificPopup( {
		removalDelay: 160,
		preloader: false,
		fixedContentPos: true,
		type: 'inline',
		midClick: true,
		overflowY: 'hidden',
	} );

	// Tabbed Content
	// const windowsize = jQuery( window ).width();

	// jQuery( window ).resize( function() {
	// 	const windowsize = jQuery( window ).width();
	// } );

	// if ( windowsize > 1023 ) {
	// 	jQuery( '.tabs-nav-button' ).on( 'click', function() {
	// 		const tabId = jQuery( this ).attr( 'href' );
	// 		const containerWrap = jQuery( this ).closest( '.tabbed-content-ctn' );
	// 		containerWrap.find( '.tabbed-content' ).hide();
	// 		containerWrap.find( `#${ tabId }` ).fadeIn( 800 ).addClass( 'current' );
	// 		containerWrap.find( '.tabs-nav-button' ).removeClass( 'current' );
	// 		jQuery( this ).addClass( 'current' );
	// 	} );
	// }
	// if ( windowsize < 1024 ) {
	// 	if (
	// 		jQuery( '.case-studies-ctn.w-slider' ).length > 0 &&
	//			// ! jQuery( '.cs-no-slider,.cs-standard' ).length > 0
	// 	) {
	// 		jQuery( '.case-studies-ctn.w-slider' )
	// 			.closest( '.wrapper' )
	// 			.parent( 'section' )
	// 			.addClass( 'mb-black-container' );
	// 	}
	// }

	// let maxHeight = 0;

	// jQuery( '.case-studies-ctn .cs-quote-text' ).each( function() {
	// 	const currentHeight = jQuery( this ).height();
	// 	if ( currentHeight > maxHeight ) {
	// 		maxHeight = currentHeight;
	// 	}
	// } );

	jQuery( '#dropdown-language-select' ).CustomSelect();

	function wrap3( $container ) {
		$container.each( function() {
			const outerBoxes = jQuery( this ).find( '.ig-single' );
			let currentIndex = 0;

			if ( jQuery( window ).width() > 1023 ) {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 3;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			} else if (
				jQuery( window ).width() < 1024 ||
				jQuery( window ).width() > 600
			) {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 2;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			} else {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 1;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			}
		} );
	}
	wrap3( jQuery( '.icon-grid-three-columns' ) );

	function wrap4( $container ) {
		$container.each( function() {
			const outerBoxes = jQuery( this ).find( '.ig-single' );
			let currentIndex = 0;

			if ( jQuery( window ).width() > 1023 ) {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 4;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			} else if (
				jQuery( window ).width() < 1024 &&
				jQuery( window ).width() > 600
			) {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 2;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			} else {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 1;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			}
		} );
	}
	wrap4( jQuery( '.icon-grid-four-columns' ) );

	function wrap2( $container ) {
		$container.each( function() {
			const outerBoxes = jQuery( this ).find( '.ig-single' );
			let currentIndex = 0;

			if ( jQuery( window ).width() > 1023 ) {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 2;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			} else if (
				jQuery( window ).width() < 1024 &&
				jQuery( window ).width() > 600
			) {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 2;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			} else {
				while ( currentIndex < outerBoxes.length ) {
					let endIndex = currentIndex + 1;
					if ( endIndex > outerBoxes.length ) {
						endIndex = outerBoxes.length;
					}
					const elementsToWrap = outerBoxes.slice(
						currentIndex,
						endIndex,
					);
					elementsToWrap.wrapAll( '<div class="ig-row"></div>' );
					currentIndex = endIndex;
				}
			}
		} );
	}
	wrap2( jQuery( '.icon-grid-two-columns' ) );
	jQuery.noConflict();

	// MAP SLIDER

	// MAP SLIDER
	if ( jQuery( '#map' ).length > 0 ) {
		const officess_location = [];
		const browserWidth = window.innerWidth || document.documentElement.clientWidth;
		let circleStyle = {};

		if ( browserWidth >= 1440 ) {
			circleStyle = { 'circle-radius': 20, 'circle-stroke-width': 12 };
		} else if ( browserWidth >= 1024 ) {
			circleStyle = { 'circle-radius': 15, 'circle-stroke-width': 8 };
		} else if ( browserWidth >= 768 ) {
			circleStyle = { 'circle-radius': 15, 'circle-stroke-width': 8 };
		} else {
			circleStyle = { 'circle-radius': 10, 'circle-stroke-width': 4 };
		}

		jQuery( '.offices__address-item' ).each( function( index ) {
			const office_lat = jQuery( this ).data( 'lat' ),
				office_long = jQuery( this ).data( 'long' ),
				office_id = jQuery( this ).data( 'id' );
			if ( office_lat && office_long ) {
				officess_location.push( {
					type: 'Feature',
					id: office_id,
					properties: { id: office_id },
					geometry: { type: 'Point', coordinates: [ office_long, office_lat ] },
				} );
			}
		} );

		const $sliderMap = jQuery( '.offices__addresses-wrapper' );

		// Make sure the first item is active by default
		if ( ! jQuery( '.offices__address-item.active' ).length ) {
			jQuery( '.offices__address-item' ).first().addClass( 'active' );
		}

		const activeOfficeDataID = jQuery( '.offices__address-item.active' ).data( 'id' );

		$sliderMap.slick( {
			centerMode: true,
			centerPadding: '280px',
			slidesToShow: 3,
			focusOnSelect: true,
			responsive: [
				{ breakpoint: 1750, settings: { centerPadding: '200px' } },
				{ breakpoint: 1440, settings: { centerPadding: '100px' } },
				{ breakpoint: 1100, settings: { centerPadding: '30px' } },
				{ breakpoint: 860, settings: { slidesToShow: 1, centerPadding: '200px' } },
				{ breakpoint: 767, settings: { slidesToShow: 1, centerPadding: '100px' } },
				{ breakpoint: 540, settings: { slidesToShow: 1, centerPadding: '30px' } },
				{ breakpoint: 380, settings: { slidesToShow: 1, centerPadding: '0px' } },
			],
		} );

		$sliderMap.slick( 'slickGoTo', activeOfficeDataID - 1 );

		mapboxgl.accessToken = 'pk.eyJ1IjoibWFya2V0aW5nZmMiLCJhIjoiY2x2eTN1bzF4Mms2aTJxcXM3Nmg0cjdneSJ9.lUik33FAMEyqF4hxhhta0g';

		let mapboxCenter, mapboxZoom;
		if ( browserWidth > 640 ) {
			mapboxCenter = [ -30, 45 ];
			mapboxZoom = 1.5;
		} else {
			mapboxCenter = [ -30, 45 ];
			mapboxZoom = 0.5;
		}

		const map = new mapboxgl.Map( {
			container: 'map',
			style: 'mapbox://styles/marketingfc/clvy4jrjp09xb01nu20ok9op1',
			center: mapboxCenter,
			zoom: mapboxZoom,
			attributionControl: false,
			pitchWithRotate: false,
		} );

		if ( browserWidth > 640 ) {
			map.scrollZoom.disable();
		}

		map.addControl( new mapboxgl.NavigationControl( { showCompass: false } ), 'top-right' );

		map.on( 'load', function() {
			map.addSource( 'point', {
				type: 'geojson',
				data: { type: 'FeatureCollection', features: officess_location },
				cluster: true,
				clusterRadius: 40,
			} );

			map.addLayer( {
				id: 'points',
				type: 'symbol',
				source: 'point',
				layout: { 'icon-image': 'map-point', 'icon-anchor': 'bottom', 'icon-size': 0.7 },
			} );

			// Center map to default active location
			const $defaultActive = jQuery( '.offices__address-item.active' );
			if ( $defaultActive.length ) {
				const defaultLat = $defaultActive.data( 'lat' );
				const defaultLong = $defaultActive.data( 'long' );
				map.flyTo( { center: [ defaultLong, defaultLat ], zoom: 8 } );
			}

			// Synchronize slider click with map
			$sliderMap.on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
				const $nextSlide = jQuery( slick.$slides[ nextSlide ] );
				const nextLat = $nextSlide.data( 'lat' );
				const nextLong = $nextSlide.data( 'long' );

				map.flyTo( { center: [ nextLong, nextLat ], zoom: 8 } );
				jQuery( '.offices__address-item' ).removeClass( 'active' );
				$nextSlide.addClass( 'active' );
			} );

			// Synchronize map point click with slider
			map.on( 'click', 'points', function( e ) {
				const features = map.queryRenderedFeatures( e.point, { layers: [ 'points' ] } );
				if ( ! features.length ) {
					return;
				}

				const feature = features[ 0 ];
				$sliderMap.slick( 'slickGoTo', feature.properties.id - 1 );
			} );
		} );
	}
} );

document.addEventListener( 'DOMContentLoaded', function() {
	// Get all the links on the page
	const links = document.querySelectorAll( 'a' );
	// Loop through each link
	links.forEach( function( link ) {
		// Check if the link is external
		const isExternal = link.hostname !== window.location.hostname;
		// If it's external, add target="_blank"
		if ( isExternal ) {
			link.setAttribute( 'target', '_blank' );
			link.setAttribute( 'rel', 'noopener noreferrer' );
		}
	} );
} );
